import React from 'react'
import { StackNavigationProp } from '@react-navigation/stack'
import { useNavigation } from '@react-navigation/native'
import { StyleProp, ViewStyle } from 'react-native'
import { TouchableSection } from '@components'
import { AppStackParamList } from '@src/navigation/types'
import { useLazyScreenPreload } from '@src/navigation/utils'

interface OpenSourceLicensesSectionProps {
  style?: StyleProp<ViewStyle>
}

const OpenSourceLicensesSection = (props: OpenSourceLicensesSectionProps) => {
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()

  // Warm the screen + 767KB licenses.json bundle so tapping the row is instant.
  useLazyScreenPreload('OpenSourceLicenses')

  const onPress = () => {
    navigation.navigate('OpenSourceLicenses')
  }

  const { style } = props

  return <TouchableSection style={style} onPress={onPress} title="Open Source Licenses" />
}

export default OpenSourceLicensesSection
